import { useState } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col, Form, Input, FormInstance } from 'antd';
import FloatingFormItem from '@/components/_common/FloatingFormItem';
import { ReportConsumablesFormValues } from '@/core/domain/reports/stock/Report.types';
import ManufacturerInfiniteSelectField from '@/components/_common/ManufacturerInfiniteSelectField';
import GroupsInfiniteSelectField from '@/components/_common/GroupsInfiniteSelectField';
import { CompaniesInfiniteSelectField } from '@/components/_common';

interface Props {
  form?: FormInstance<ReportConsumablesFormValues>;
}

function ConsumableReportForm({ form }: Props) {
  const intl = useIntl();

  const handleFormValuesChange = (
    valuesChanged: ReportConsumablesFormValues,
  ) => {
    toggleSelectCompany(valuesChanged);
  };

  const [selectedCompany, setSelectCompany] = useState<Array<number>>();

  const toggleSelectCompany = (value: ReportConsumablesFormValues) => {
    setSelectCompany(value.companies);
  };

  return (
    <Form form={form} onValuesChange={handleFormValuesChange}>
      <Row gutter={[8, 8]}>
        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.description',
            })}
            name="descriptionFrom"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.descriptionUpUntil',
            })}
            name="descriptionTo"
          >
            <Input />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.group',
            })}
            name="groups"
          >
            <GroupsInfiniteSelectField
              queryFilter={{ active: true }}
              labelValue
              mode="multiple"
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem label={'Fabricantes'} name="manufacturer">
            <ManufacturerInfiniteSelectField
              queryFilter={{ active: true }}
              labelValue
              mode="multiple"
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={24} lg={24}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.companies',
            })}
            name="companies"
          >
            <CompaniesInfiniteSelectField
              queryFilter={{ active: true }}
              mode="multiple"
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.localization',
            })}
            name="fromLocalization"
          >
            <Input
              disabled={!!selectedCompany?.length && selectedCompany.length > 1}
            />
          </FloatingFormItem>
        </Col>

        <Col xs={24} sm={12} md={12} lg={12}>
          <FloatingFormItem
            label={intl.formatMessage({
              id: 'consumables.modal.report.form.localizationUpUntil',
            })}
            name="toLocalization"
          >
            <Input
              disabled={!!selectedCompany?.length && selectedCompany.length > 1}
            />
          </FloatingFormItem>
        </Col>

        {/* TODO: Solicitado remoção na UL-2950
         <Col span={24}>
          <Typography.Title level={5}>
            <FormattedMessage id="parts.modal.report.form.order" />
          </Typography.Title>
          <Form.Item name="orderByColumn" labelAlign="left">
            <Radio.Group>
              <Radio value={OrderByColumnReport.description}>
                <FormattedMessage id="parts.modal.report.form.descriptionOrder" />
              </Radio>
              <Radio value={OrderByColumnReport.code}>
                <FormattedMessage id="parts.modal.report.form.internalCode" />
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col> */}
      </Row>
    </Form>
  );
}

export default ConsumableReportForm;
